export default class Catalog {
  constructor({ id, name, categories }) {
    this.id = id;
    this.name = name;
    this._categoriesCount = 0;
    this._categories = [];
  } 
  
  get categories() { return this._categories; }
  get categoriesCount() { return this._categoriesCount; }

  set categories(categories) {
    this._categories = categories;
  }  

  static format(catalog) {
    return {
      id: catalog.id,
      name: catalog.title,
    };
  }
}